export interface Notification {
    NotificationId: string;
    SourceEntityId: string;
    SourceEntityType: string;
    TargetEntityId: string;
    TargetEntityType: string;
    Status: NotificationStatus;
    Message: string;
    StatusChangeDate: Date;
    CreateDate: Date;
    CreateBy: string;
    TimeAgo: string;
}

export enum NotificationStatus {
    Created = "Created",
    Delivered = "Delivered",
    Read = "Read"
}